// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{background-color:#373b54}.menu-nav ul{display:grid;grid-gap:20px;padding:0;list-style:none;grid-template-columns:repeat(5, 1fr);justify-items:center;font-size:24px}li{white-space:nowrap}li a{color:#777}li a:hover{color:#fff}li .selected{color:#fff;border-bottom:4px solid #fff;padding-bottom:4px}", ""]);
// Exports
module.exports = exports;
